import { render, staticRenderFns } from "./ListOfBlockchains.vue?vue&type=template&id=a58aa4ec&scoped=true&"
import script from "./ListOfBlockchains.vue?vue&type=script&lang=js&"
export * from "./ListOfBlockchains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58aa4ec",
  null
  
)

export default component.exports